import React from 'react';
import PropTypes from 'prop-types';

import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { getCpoPath } from 'client/data/models/cpo';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';

import { ArticleTable } from 'site-modules/shared/components/editorial/article-table/article-table';

import './cpo-program-overview.scss';

export function CpoProgramOverviewUI({ cpoProgramOverview, isMobile }) {
  return (
    <ArticleTable
      entry={cpoProgramOverview}
      isMobile={isMobile}
      className="cpo-program-overview mt-1_5 mb-2 px-1_25 py-2 rounded-16 bg-cool-gray-100 mx-auto"
      tableClassName="bg-white"
    />
  );
}

CpoProgramOverviewUI.propTypes = {
  cpoProgramOverview: CmsEntities.Content,
  isMobile: PropTypes.bool,
};

CpoProgramOverviewUI.defaultProps = {
  cpoProgramOverview: DEFAULT_CONTENT,
  isMobile: false,
};

export const CpoProgramOverview = connectToModel(CpoProgramOverviewUI, {
  cpoProgramOverview: bindToContent(getCpoPath(), 'cpo-program-overview'),
});
